<!-- Categories Start -->

<div class="subcategory_brand" margin-bottom [style.background-image]="'url('+category.cover+')'">
    <h1 no-margin margin-horizontal-lg fs30 *ngIf="lang == 'ar'">{{category.name_ar}}</h1>
    <h1 no-margin margin-horizontal-lg fs30 *ngIf="lang != 'ar'">{{category.name_en}}</h1>
</div>
<!-- Categories End -->